import React, { Component } from 'react';
import SlateTextInput from '../../Shared/SlateTextInput';
import AuthButton from '../../../containers/Forms/AuthButton';
import tryMe from '../../../helpers/tryMe';

export default class FormResetPassword extends Component {
  UNSAFE_componentWillMount() {
    this.props.actions.setFormState({
      password: '',
      confirmPassword: '',
      dataErrors: {
        password: '',
        confirmPassword: '',
      },
    });
  }

  render() {
    const { actions, state, t, formError } = this.props;
    const dataErrors = tryMe(state.dataErrors);

    return (
      <form onKeyPress={actions.handleKeyPress}>
        <div style={{ marginBottom: 16 }}>
          <SlateTextInput
            name="password"
            type="password"
            label={t('resetPassword:password')}
            value={tryMe(state).password || ''}
            onChange={actions.handleChange}
            onBlur={actions.handleBlur}
            autoComplete="new-password"
            error={dataErrors.password}
            fullWidth
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <SlateTextInput
            name="confirmPassword"
            type="password"
            label={t('resetPassword:confirmPassword')}
            value={tryMe(state).confirmPassword || ''}
            onChange={actions.handleChange}
            onBlur={actions.handleBlur}
            autoComplete="new-password"
            error={dataErrors.confirmPassword}
            fullWidth
          />
        </div>
        <AuthButton
          onClick={actions.handleSubmit}
          entityName={state.entityName}
        >
          {t('resetPassword:updatePassword')}
        </AuthButton>
        {formError && (
          <div className="auth-form-error">
            {formError}
          </div>
        )}
      </form>
    );
  }
}
